import { Breadcrumb, Button, Col, Form, Image, Input, Row, Steps, Switch, message } from "antd";
import "../spf.scss";
import "./spf-prefactor.scss";
import { HomeOutlined } from "@ant-design/icons";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { complexDigitToman, convertPersian, convertToJalaliWithoutTime, formatMsisdn, isEmpty, validateInput } from "../../../../tools/tools";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import PrintPrefactor from "../../../auxiliary/print/printPrefactor";
import IncressCharge from "../../../auxiliary/incressCharge/charge";
import { clearGlobalFormData, globalValue } from "../../../../reducer/serviceReducerGlobala";
import Loading from "../../../auxiliary/loader/loading";
import { useLayout } from "../../../layouts/layout";
import SPFShopLayout from "../spf-shop-layout";
import { switchPlanID } from "../../../../tools/services";
const SPFPrefactor = () => {
	const { setLayout } = useLayout();
	const [t] = useTranslation("global");
	const { calculateSPCommissionPrice, isValidDiscountCode, queryDiscountCodeByCode, queryMethodOfReceiptByPlanId, redirectToNeginWalletGateWay } =
		useDealer();
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	const nav = useNavigate();
	const [searchParam] = useSearchParams();
	const { queryTaxPercent } = useAPIPublic();
	const [messageApi, contextHolder] = message.useMessage();
	//show Image Upload
	const [isVisible, setIsVisible] = useState(false);

	//state show msisdn and gift
	const [msisdnList, setMsisdnList] = useState([]);
	const [giftChecked, setGiftChecked] = useState(true);

	const [profile, setProfile] = useState({});
	const [bundle, setBundle] = useState({});
	const [token, setToken] = useState("");
	const [smsmobileno, setSmsmobileno] = useState("");
	const [txtCertType, setTxtCertType] = useState("");
	//state tax percent
	const [wallet, setWallet] = useState(0);
	const [taxPercent, setTaxPercent] = useState(0);
	const [calcTax, setCalcTax] = useState(0);
	const [commission, setCommission] = useState(0);
	const [profit, setProfit] = useState(0);
	const [totalPay, setTotalPay] = useState(0);

	const [doDelete, setDoDelete] = useState(false);
	const [discount, setDiscount] = useState(0);
	const [isDiCount, setIsDiCount] = useState(false);
	const [discountCode, setDiscountCode] = useState("");
	const [percentDiscount, setPercentDiscount] = useState(0);
	const [maxDiscount, setMaxDiscount] = useState(0);
	const [totalDiscount, setTotalDiscount] = useState(0);

	const [isLoading, setIsLoading] = useState(false);
	const [localInvoiceId, setLocalInvoiceId] = useState("");

	const [bundleCommission, setBundleCommission] = useState("");

	const bankRef = useRef("");
	// Incress Charge
	const [openIncress, setOpenIncress] = useState(false);
	const handleChange = (checked) => {
		try {
			setGiftChecked(checked);
			setMsisdnList(
				msisdnList.map((item) => {
					return { msisdn: item.msisdn, isgift: checked };
				}),
			);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		try {
			if (!isEmpty(searchParam.get("localInvoiceId"))) {
				setMsisdnList(formData?.another?.spForeign?.spMsisdn || []);
				setProfile(formData?.another?.spForeign?.profile || {});
				setBundle(formData?.another?.spForeign?.spbundle || {});
				setToken(formData?.another?.spForeign?.token || {});
				setSmsmobileno(formData?.another?.spForeign?.smsmobileno);

				const getLocalInvoiceID = searchParam.get("localInvoiceId");
				setLocalInvoiceId(getLocalInvoiceID);
				setOpenIncress(true);

				setTxtCertType(formData?.another?.spForeign?.txtCertType);

				// بک‌آپ لوکال‌استوریج مصرف شد؛ دیگه لازم نیست بمونه (وگرنه برای درخواست بعدی نشت می‌کنه)
				dispatch(clearGlobalFormData(["spForeign"]));
			} else {
				setProfile(formData?.from?.spForeign?.profile || formData?.another?.spForeign?.profile || {});
				setMsisdnList(formData?.from?.spForeign?.spMsisdn || formData?.another?.spForeign?.spMsisdn || []);
				setBundle(formData?.from?.spForeign?.spbundle || formData?.another?.spForeign?.spbundle || {});
				setToken(formData?.from?.spForeign?.token || formData?.another?.spForeign?.token || {});
				setSmsmobileno(formData?.from?.spForeign?.smsmobileno || formData?.another?.spForeign?.smsmobileno);
				setTxtCertType(formData?.from?.spForeign?.txtCertType || formData?.another?.spForeign?.txtCertType);
			}
		} catch (error) {
			console.error(error);
		}
	}, []);

	useEffect(() => {
		const CallInitialService = async () => {
			try {
				let response = await queryTaxPercent();
				if (response) {
					setTaxPercent(response);
				}
			} catch (error) {
				console.error(error);
			}
		};
		CallInitialService();
	}, []);

	useEffect(() => {
		setWallet(formData?.another?._currentUser?.walletAmount);
	}, [formData?.another?._currentUser?.walletAmount]);

	useEffect(() => {
		const CallAPI = async () => {
			try {
				if (!!bundle && msisdnList.length > 0) await handleCommission();
				if (taxPercent > 0) calculate();
			} catch (error) {
				console.error(error);
			}
		};
		CallAPI();
	}, [taxPercent, commission, discountCode]);

	const handleCommission = async () => {
		try {
			let payload = {
				discountcode: discountCode,
				spbundleid: bundle.bundleSalesSimId,
				iccid: bundle.iccid,
				msisdn: msisdnList.length > 0 ? msisdnList[0]?.msisdn : 0,
				certno: profile?.certno,
			};
			let response = await calculateSPCommissionPrice(payload);
			if (response) {
				setCommission(response?.commission);
				setProfit(response?.packageSalesCommission);
				setBundleCommission(response?.bundleSalesCommission);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const calculate = () => {
		try {
			let _bundlePrice = bundle.bundlePrice;
			let _taxPay = (_bundlePrice * taxPercent) / 100;
			let _counSim = msisdnList?.length;
			let _totalBundlePrice = _counSim * _bundlePrice;
			let _totalPrice = _totalBundlePrice + _taxPay;

			setTotalPay(_totalPrice);
			setCalcTax(_taxPay);
			if (isDiCount) {
				let _totalDiscountOnPrice = (_totalPrice * percentDiscount) / 100;

				setDiscount(maxDiscount);

				if (_totalDiscountOnPrice > maxDiscount) {
					_totalDiscountOnPrice = _totalPrice - maxDiscount;
					setDiscount(_totalDiscountOnPrice);
				} else {
					_totalDiscountOnPrice = _totalPrice - _totalDiscountOnPrice;
				}
				setTotalPay(_totalDiscountOnPrice);
			}
		} catch (error) {
			console.error(error);
		}
	};

	//discount

	const handldeFrmDiscount = async (value) => {
		try {
			setIsLoading(true);
			if (doDelete) {
				setDoDelete(false);
				setIsDiCount(false);
				setDiscountCode(0);
				setPercentDiscount(0);
				setMaxDiscount(0);
			} else {
				let payload = {
					discountcode: value.discount,
					bundlesalessimid: bundle.bundleSalesSimId,
					certno: profile?.certno,
					planid: switchPlanID().simPurchaseForeign,
				};
				let resValid = await isValidDiscountCode(payload);
				if (resValid && !resValid.HasError) {
					payload = {
						discountcode: value.discount,
					};
					let response = await queryDiscountCodeByCode(payload);
					if (response) {
						setDoDelete(true);
						setIsDiCount(true);
						setDiscountCode(value.discount);
						setPercentDiscount(!isEmpty(response.inT_DiscountPercent) ? response.inT_DiscountPercent : 0);
						setMaxDiscount(!isEmpty(response.inT_MaxDiscountPrice) ? response.inT_MaxDiscountPrice : 0);
					}
				}
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	const handleCallBackCharge = (value) => {
		try {
			if (value?.length > 0) {
				dispatch(globalValue({ spForeign: formData.from.spForeign }));
				bankRef.current.innerHTML = value;
				document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
			} else {
				setLocalInvoiceId("");
				setOpenIncress(false);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleSubmitPage = async () => {
		try {
			setIsLoading(true);
			if (wallet - Math.abs(commission) >= 0) {
				let payload = {
					planid: switchPlanID().simPurchaseForeign,
					cityid: profile?.cityid,
				};
				let resMethod = await queryMethodOfReceiptByPlanId(payload);
				if (resMethod) {
					let methodOfReceiptId = resMethod?.find((item) => item.methodIsDefault).methodOfReceiptId;

					let count = 0;
					msisdnList.forEach((item) => {
						if (item.isgift) count++;
					});

					payload = {
						bundlesalessimgiftid: bundle?.bundleSalesSimGiftId,
						giftcount: count,
						certno: token,
						methodreceiptid: methodOfReceiptId,
						msisdn: msisdnList.map((item) => item.msisdn),
						iccid: bundle.iccid,
						planid: switchPlanID().simPurchaseForeign,
						bundlesalesimid: bundle.bundleSalesSimId,
						discountcode: discountCode,
					};
					let response = await redirectToNeginWalletGateWay(payload);
					if (response) {
						console.log(response);
						nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Document, {
							state: response,
						});
					} else {
					}
				}
			} else {
				messageApi.open({
					type: "error",
					content: "موجودی کیف پول کافی نمی باشد.",
				});
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		setLayout(
			<PrintPrefactor
				titlePage="پیش‌فاکتور فروش سیم‌کارت"
				listPrint={[
					{
						label: <>سیم‌کارت + بسته آغازین</>,
						value: (
							<>
								<span dir="ltr">{complexDigitToman(bundle?.bundlePrice)}</span> تومان
							</>
						),
					},
					{
						label: <>مالیات ({taxPercent}درصد)</>,
						value: (
							<>
								<span dir="ltr">{complexDigitToman(calcTax)} </span> تومان
							</>
						),
					},
					isDiCount && {
						label: (
							<>
								تخفیف <span>({percentDiscount} درصد)</span>
							</>
						),
						value: (
							<>
								<span dir="ltr">{complexDigitToman(discount)} </span>تومان
							</>
						),
					},
					{
						label: "مبلغ قابل دریافت از مشتری",
						value: (
							<>
								<span dir="ltr">{complexDigitToman(totalPay)} </span>تومان
							</>
						),
					},
					{
						label: "مبلغ برداشت از کیف پول",
						value: (
							<>
								<span dir="ltr">{complexDigitToman(commission)} </span> تومان
							</>
						),
					},
					// {
					//   label: "سود شما از این فروش",
					//   value: (
					//     <>
					//       <span dir="ltr">{complexDigitToman(commission)} </span> تومان
					//     </>
					//   ),
					// },
					{
						label: "مجموع",
						value: (
							<>
								<span dir="ltr">{complexDigitToman(totalPay)}</span>
							</>
						),
					},
				]}
			/>,
		);
	}, []);
	return (
		<>
			<SPFShopLayout>
				{contextHolder}
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.foreigners.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.foreigners.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={3}
											items={[
												{
													title: "بسته آغازین",
												},
												{
													title: "احراز هویت",
												},
												{
													title: "اطلاعات هویتی",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "سند",
												},
											]}
										/>
									</div>
								</div>
								<div className="g-prefactor">
									<div className="holder-row-prefactor">
										<Row gutter={16}>
											<Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
												<div className="for-pay-client">
													<h3>صورت حساب مشتری</h3>
													<div className="holder-box">
														<div className="holder-simcard">
															<div className="holder-list-msisdn">
																{msisdnList.map((item, key) => (
																	<div key={key}>
																		<div className="item">
																			<div className="row-item">
																				<div className="holder-icon">
																					<i className="icon-simcard"></i>
																				</div>
																				<div className="holder-text">
																					<h4>
																						{bundle?.bundleName} <span dir="ltr">{formatMsisdn(item.msisdn)}</span>
																					</h4>
																					<p>
																						{bundle?.attribute?.map((item, key) => (
																							<React.Fragment key={key}>{item.briefDescription} </React.Fragment>
																						))}
																					</p>
																				</div>
																				<div className="holder-option"></div>
																			</div>
																		</div>
																		{item.isgift && bundle?.bundleSalesSimGiftId?.length > 0 && (
																			<div className="item gift">
																				<div className="row-item">
																					<div className="holder-icon">
																						<i className="icon-gift-box"></i>
																					</div>
																					<div className="holder-text">
																						<h4>سیم کارت هدیه</h4>
																						{/* <p>به همراه 2 گیگ اینترنت رایگان یک ماهه + 50 دقیقه مکالمه</p> */}
																					</div>
																				</div>
																			</div>
																		)}
																	</div>
																))}
															</div>
															<div className="holder-gift">
																<div className="holder-option">
																	{bundle?.bundleSalesSimGiftId?.length > 0 && (
																		<Switch className="switch-gift" checked={giftChecked} onChange={handleChange} />
																	)}
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<h4>
																اطلاعات هویتی{" "}
																<Link to={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Profile}>
																	<i className="icon-edit"></i>
																</Link>
															</h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">نام:</div>
																	<div className="value">{profile?.fname}</div>
																</div>
																<div className="item">
																	<div className="label">نام خانوادگی:</div>
																	<div className="value">{profile?.lname}</div>
																</div>
																<div className="item">
																	<div className="label">نوع مدرک شناسایی:</div>
																	<div className="value">{txtCertType}</div>
																</div>
																<div className="item">
																	<div className="label">تاریخ تولد:</div>
																	<div className="value">{convertToJalaliWithoutTime(profile?.birthdate)}</div>
																</div>
																{txtCertType !== "گذرنامه" && (
																	<div className="item">
																		<div className="label">نام پدر:</div>
																		<div className="value">{profile?.fathername}</div>
																	</div>
																)}

																<div className="item">
																	<div className="label">شماره مدرک شناسایی:</div>
																	<div className="value">{profile?.certno}</div>
																</div>
																<div className="item">
																	<div className="label">جنسیت:</div>
																	<div className="value">{profile?.txtGender}</div>
																</div>
																<div className="item">
																	<div className="label">کشور:</div>
																	<div className="value">{profile?.txtCountry}</div>
																</div>
																<div className="item">
																	<div className="label">زبان:</div>
																	<div className="value">{profile?.txtLanguage}</div>
																</div>
																<div className="item">
																	<div className="label">موبایل:</div>
																	<div className="value" dir="ltr">
																		{"0" + formatMsisdn(smsmobileno?.slice(1) || "")}
																	</div>
																</div>
																<div className="item">
																	<div className="label">پست الکترونیکی:</div>
																	<div className="value">{profile?.email}</div>
																</div>
																<div className="item">
																	<div className="label">تصویر کارت ملی:</div>
																	<div className="value">
																		<div className="show-document">
																			<Button onClick={() => setIsVisible(true)} type="link">
																				بارگذاری شده
																			</Button>
																			<Image
																				preview={{
																					visible: isVisible,
																					onVisibleChange: (value) => setIsVisible(value),
																				}}
																				src={profile?.photo}
																				style={{ display: "none" }}
																			/>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<h4>
																اطلاعات آدرس <i className="icon-edit"></i>
															</h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">استان:</div>
																	<div className="value">{profile?.txtProvince}</div>
																</div>
																<div className="item">
																	<div className="label">شهر:</div>
																	<div className="value">{profile?.txtCity}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان اصلی:</div>
																	<div className="value">{profile?.mainstreet}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان فرعی:</div>
																	<div className="value">{profile?.auxiliaryroad}</div>
																</div>
																<div className="item">
																	<div className="label">کوچه:</div>
																	<div className="value">{profile?.alley}</div>
																</div>
																<div className="item">
																	<div className="label">پلاک:</div>
																	<div className="value">{profile?.buildingno}</div>
																</div>
																<div className="item">
																	<div className="label">طبقه:</div>
																	<div className="value">{profile?.floor}</div>
																</div>
																<div className="item">
																	<div className="label">واحد:</div>
																	<div className="value">{profile?.unit}</div>
																</div>
																<div className="item">
																	<div className="label">کدپستی:</div>
																	<div className="value">{profile?.postalcode}</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</Col>
											<Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
												<div className="for-pay-agent">
													<h3>صورت حساب فروشنده</h3>
													<div className="holder-box">
														<div className="holder-form-dicount">
															<Form
																layout="vertical"
																onFinish={handldeFrmDiscount}
																initialValues={{
																	deleted: doDelete,
																}}>
																<Form.Item label="کد تخفیف" name="discount" rules={[validateInput({ t: t, validate: true })]}>
																	<Input
																		autoComplete="off"
																		onChange={(e) => (e.target.value = convertPersian(e.target.value))}
																		suffix={
																			<Button htmlType="submit" className="btn-normal btn-aptel">
																				{isDiCount ? <>حذف</> : <>اعمال</>}
																			</Button>
																		}
																	/>
																</Form.Item>
															</Form>
														</div>
														<div className="holder-list-pay">
															<ul>
																<li>
																	<div className="label">سیم‌کارت + بسته آغازین</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(bundle?.bundlePrice)}</span> <small>تومان</small>
																	</div>
																</li>
																<li>
																	<div className="label">مالیات ({taxPercent}درصد)</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(calcTax)}</span> تومان
																	</div>
																</li>
																{isDiCount && (
																	<li>
																		<div className="label">
																			تخفیف{" "}
																			<span>
																				({percentDiscount} درصد {maxDiscount > 0 && <> سقف {complexDigitToman(totalDiscount)} تومان</>})
																			</span>
																		</div>
																		<div className="value">
																			<span dir="ltr">{complexDigitToman(totalDiscount)}</span> تومان
																		</div>
																	</li>
																)}

																<li>
																	<div className="label">مبلغ قابل دریافت از مشتری</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(totalPay)}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">
																		<div className="label">{commission > 0 ? <> مبلغ واریز به کیف پول</> : <>مبلغ برداشت از کیف پول</>}</div>
																	</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(commission))}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">سود شما از این فروش</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(profit + bundleCommission)} </span> تومان
																	</div>
																</li>
															</ul>
															{wallet - Math.abs(commission) >= 0 || commission > 0 ? (
																<div className="hold-message success">
																	<p>این {commission > 0 ? <> مبلغ به کیف پول شما واریز می‌شود</> : <>این مبلغ از کیف پول شما برداشت می‌شود</>}</p>

																	<h3>
																		{" "}
																		<span dir="ltr">{complexDigitToman(Math.abs(commission))} </span> تومان
																	</h3>
																</div>
															) : (
																<div className="hold-message error">
																	<div className="row-message">
																		<div className="holder-text">
																			<h3>اعتبار شما کافی نمی‌باشد</h3>
																			<ul>
																				<li>
																					<div className="label">کسری اعتبار: </div>
																					<div className="value">
																						<span dir="ltr">{complexDigitToman(Math.abs(wallet + commission))} </span> تومان
																					</div>
																				</li>
																			</ul>
																		</div>
																		<div className="holder-acction">
																			<div className="holder-button">
																				<Button className="btn-normal btn-aptel" htmlType="button" onClick={() => setOpenIncress(true)}>
																					افزایش اعتبار
																				</Button>
																			</div>
																		</div>
																	</div>
																</div>
															)}
														</div>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="row-button">
									<div className="holder-button">
										<Button
											className="btn-normal btn-print"
											onClick={() => {
												window.print();
											}}
											type="default"
											icon={<i className="icon-print"></i>}>
											چاپ پیش‌فاکتور
										</Button>
									</div>
									<div className="holder-button">
										<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmitPage}>
											مرحله بعد
										</Button>
										<Button
											className="btn-normal"
											onClick={() => {
												nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Profile);
											}}
											type="default">
											بازگشت
										</Button>
									</div>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</SPFShopLayout>

			<IncressCharge
				open={openIncress}
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_SPF}
				msisdn={formData?.another?._currentUser?.telnoone}
				price={Math.abs(commission)}
				callback={handleCallBackCharge}
				localInvoiceId={localInvoiceId}
			/>

			<Loading isOpen={isLoading} />
			<div ref={bankRef}></div>
		</>
	);
};

export default SPFPrefactor;
